<button (click)="toggleButton()"
        class="unread-btn" [ngClass]="{'accent': isUnread}">
  <ng-container *ngIf="!isUnread; else unread">
    <i class="far fa-circle icon"></i>
    <span class="title">All</span>
  </ng-container>

  <ng-template #unread>
    <i class="far fa-dot-circle icon"></i>
    <span class="title">Unread</span>
  </ng-template>
</button>
